import type { ActiveFilter } from '../../../types/filters';

export const PANE_FILTERS_STORAGE_PREFIX = 'mestti:pane-filters:';

export const getPaneFilterStorageKey = (pathname: string, scope: string): string =>
  `${pathname}:${scope}`;

export const buildPaneFilterSessionKey = (pathname: string, scope: string): string =>
  `${PANE_FILTERS_STORAGE_PREFIX}${getPaneFilterStorageKey(pathname, scope)}`;

export const loadPanePersistedFilters = (
  pathname: string,
  scope = 'default',
): ActiveFilter[] | null => {
  try {
    const raw = sessionStorage.getItem(buildPaneFilterSessionKey(pathname, scope));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return null;
    return parsed as ActiveFilter[];
  } catch {
    return null;
  }
};

export const savePanePersistedFilters = (
  pathname: string,
  scope: string,
  filters: ActiveFilter[],
): void => {
  try {
    const key = buildPaneFilterSessionKey(pathname, scope);
    sessionStorage.setItem(key, JSON.stringify(filters));
  } catch {
    // Ignora modo privado ou quota.
  }
};

/** Remove filtros persistidos de um pane (ex.: ao fechar aba). */
export const clearPanePersistedFiltersForPath = (pathname: string): void => {
  try {
    const pathPrefix = `${PANE_FILTERS_STORAGE_PREFIX}${getPaneFilterStorageKey(pathname, '')}`;
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(pathPrefix)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // Ignora modo privado ou quota.
  }
};
